(function ($) {
	class SearchAjaxAll {
		constructor() {
			// this.searchForm = $('form.search-form');
			this.openButton = $('xxx');
			this.closeButton = $('xxx');
			this.searchField = $('form.search-form #search');
			this.resultsElement = $('form.search-form #search-online-results');
			this.loaderElement = $('form.search-form .loader');
			this.init();
			this.isSearchFormOpen = false;
			this.isLoaderVisible = false;
		}

		init() {
			if (!this.searchField.length) {
				this.resultsElement.html('');
				return;
			}

			this.openButton.on('click', () => {
				this.openSearchForm();
			});

			this.closeButton.on('click', () => {
				this.closeSearchForm();
			});

			$(document).on('keydown', (e) => {
				this.keyPressDispatcher(e);
			});

			this.searchField.on('keyup', () => {
				this.getResults();
			});
		}

		getResults() {
			let keyword = this.searchField.val();

			if (keyword) {
				// this.loaderElement.addClass('active');

				$.ajax({
					url: rblnConfig.ajaxUrl,
					type: 'post',
					data: {
						action: 'search_ajax_all',
						nonce: rblnConfig.ajaxNonce,
						keyword: keyword
					},
					success: (data) => {
						this.resultsElement.html(data);
						console.log('Success');
					},
					error: () => {
						console.log('Error');
					}
				});
			} else {
				// this.loaderElement.removeClass('active');
				this.resultsElement.html('');
			}
		}

		keyPressDispatcher(e) {
			// 83 = s
			if (e.keyCode === 83 && !this.isSearchFormOpen && !$('input, textarea').is(':focus')) {
				this.openSearchForm();
			}
			// 27 = esc
			if (e.keyCode === 27 && this.isSearchFormOpen) {
				this.closeSearchForm();
			}
		}

		openSearchForm() {
			// TODO
			this.searchField.val('');
			setTimeout(() => this.searchField.focus(), 301);
			this.isSearchFormOpen = true;
		}

		closeSearchForm() {
			// TODO
			this.isSearchFormOpen = false;
		}
	}

	new SearchAjaxAll();
})(jQuery);
